import React from 'react';
import PropTypes from 'prop-types';
import { DataItem, PaperContent } from 'virtues-bootstrap';
import { map } from 'ramda';
import { withTranslation } from 'react-i18next';

import { mapIndex } from 'utilities/ramda';

import s from './styles.module.scss';

const UserDetailedInfo = ({ data, t }) => (
  <PaperContent className={s.sidebarPaper} data-test="contactsDetails">
    {map(
      ({ title, items }) => (
        <DataItem className={s.dataItem} key={title} title={t(title)}>
          {mapIndex(
            ({ title: itemTitle, value }, index) => (
              <div key={index}>
                {itemTitle && `${t(itemTitle)}:`} {value}
              </div>
            ),
            items,
          )}
        </DataItem>
      ),
      data,
    )}
  </PaperContent>
);

UserDetailedInfo.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      items: PropTypes.arrayOf(
        PropTypes.shape({
          title: PropTypes.string,
          value: PropTypes.string.isRequired,
        }),
      ).isRequired,
    }),
  ).isRequired,
  t: PropTypes.func.isRequired,
};

export default withTranslation()(UserDetailedInfo);
